import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';

import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import furoApi from '../api/FuroApi';
import {ErrorResponse, InventoryTransportLetter, Partner, SaveInventoryTransportLetterRequest} from '../api/dtos/dtos';
import * as paths from '../paths';
import {ErrorAlert} from '../common/ErrorAlert';
import InventoryTransportLetterForm from './InventoryTransportLetterForm';
import {showDeleteSuccessNotification, showErrorModal, showSaveSuccessNotification} from '../utils/dialogs';

interface State {
  letter?: InventoryTransportLetter;
  users: string[];
  error?: ErrorResponse;
  partners: Partner[];
}

class CreateInventoryTransportLetterPage extends React.Component<RouteComponentProps, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    users: [],
    partners: []
  };

  public componentDidMount() {
    this.initLetter();
    this.loadUsers();
  }

  public render(): React.ReactNode {
    const {letter, users, partners, error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <InventoryTransportLetterForm
          editable={true}
          transportLetter={letter}
          users={users}
          onFormSubmit={this.onSave}
          onFormCancel={this.onCancel}
          onPartnerSearch={this.searchPartner}
          onPartnerDelete={this.deletePartner}
          partners={partners}
        />

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private initLetter = () => {
    this.setState({
      letter: undefined,
      error: undefined,
    });
  };

  private loadUsers = () => {
    const promise = furoApi.users.getUsers()
      .then((users) => this.setState({users: users.map(u => u.userName).filter(Boolean) as string[]}))
      .catch(this.onError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSave = (letter: SaveInventoryTransportLetterRequest) => {
    const promise = furoApi.inventoryTransportLetters.create(letter)
      .then(this.onCreateSuccess)
      .catch((e) => {
        showErrorModal(e.details.message);
      });
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onCreateSuccess = (id: number) => {
    showSaveSuccessNotification();
    this.setState({error: undefined}, () => {
      this.props.history.replace(paths.viewInventoryTransportLetterPath(id));
    });
  };

  private onError = (error: ErrorResponse) => {
    this.setState({error});
  };

  private onCancel = () => {
    this.props.history.goBack();
  };

  private searchPartner = (value: string) => {
    furoApi.incomingInvoices.searchPartners(value)
      .then((partners) => this.setState({partners}))
      .catch(this.onError);
  };

  private deletePartner = (id: number) => {
    furoApi.incomingInvoices.deletePartner(id)
      .then((_) => this.onPartnerDeleted(id))
      .catch(this.onError);
  };

  private onPartnerDeleted = (id: number) => {
    showDeleteSuccessNotification();
    const {partners} = this.state;
    const idx = partners.findIndex(p => p.id === id);
    if (idx > -1) {
      partners.splice(idx, 1);
      this.setState({partners});
    }
  };
}

export default withRouter(CreateInventoryTransportLetterPage);




// WEBPACK FOOTER //
// ./src/inventory-transport-letters/CreateInventoryTransportLetterPage.tsx